/**
 * Ghost Performance Service
 * Handles ghost performance report data fetching
 */

import { IS_MOCK, MOCK_DELAY } from '../../constants/config';
import { generateMockGhostPerformanceData } from '../mock/mockGhostPerformance';
import { delay } from '../mock/mockData';
import type { GhostPerformanceData, ReportFilters } from '../../types/reports';

class GhostPerformanceService {
  /**
   * Get ghost performance report data
   */
  static async getGhostPerformanceData(
    filters?: ReportFilters,
    page: number = 1,
    pageSize: number = 10
  ): Promise<GhostPerformanceData & { currentPage: number; totalPages: number }> {
    if (IS_MOCK) {
      await delay(MOCK_DELAY / 2);
      const data = generateMockGhostPerformanceData();
      const totalPages = Math.ceil(data.totalGhosts / pageSize);
      
      return {
        ...data,
        currentPage: page,
        totalPages,
      };
    } else {
      const params = new URLSearchParams({
        page: page.toString(),
        pageSize: pageSize.toString(),
      });
      
      if (filters?.dateRange) params.append('dateRange', filters.dateRange);
      if (filters?.region) params.append('region', filters.region);
      if (filters?.ghostId) params.append('ghostId', filters.ghostId);
      
      const response = await fetch(`/api/reports/ghost-performance?${params.toString()}`);
      if (!response.ok) {
        throw new Error('Failed to fetch ghost performance data');
      }
      return response.json();
    }
  }
}

export { GhostPerformanceService };

